export class Despacho {    
    calleDespacho?: string;
    referenciaDespacho?: string;
    fechaEnvio?: Date;
    horarioEnvio?: string;  
    distritoId?: number;
    numeroCelular?:string;
    clientEmail?:string       
  }